import * as React from 'react';
import Text from 'components/Text';

type Props = {
  date?: Date;
};

function Greeting(props: Props) {
  const hour = props.date ? props.date.getHours() : new Date().getHours();

  let greeting = '';

  if (hour < 12) {
    greeting = 'Good Morning';
  } else if (hour < 18) {
    greeting = 'Good Afternoon';
  } else {
    greeting = 'Good Evening';
  }

  return <Text>{greeting}</Text>;
}

export default Greeting;
